import React, { FC } from "react";
import { TableCell, TableHead, TableRow } from "@mui/material";

interface IGetTableCell {
  width?: number;
  size?: number;
}

export const TableHeader: FC = () => {
  const getTableCell = (text: string, options?: IGetTableCell) => {
    const { size, width } = options || {};
    return (
      <TableCell
        align={width ? "left" : "center"}
        sx={{
          width: width || 80,
          fontFamily: "CircularStd",
          fontSize: size || 12,
        }}
      >
        <strong>{text}</strong>
      </TableCell>
    );
  };

  return (
    <TableHead>
      <TableRow>
        {getTableCell("Channel", { width: 185 })}
        {getTableCell("Status")}
        {getTableCell("Impressions")}
        {getTableCell("Plays")}
        {getTableCell("Watch")}
        {getTableCell("Likes")}
        {getTableCell("Placement")}
      </TableRow>
    </TableHead>
  );
};
